import axiosInstance from "@/api/axios-instance";

export async function updateUtilizedSessions(
  usage_id: string,
  new_utilization_session__count: number
) {
  const response = await axiosInstance.patch("/usage/update-utilized", {
    usage_id,
    new_utilization_session__count,
  });

  if (!response.status.toString().startsWith("2")) {
    throw new Error("failed updating utilized session quantity");
  }

  return response.data;
}
